import LinkIcon from '@atlaskit/icon/core/link';
import { type Hyperlink } from '@databases/types/database';
import { getFallbackHyperlinkLabel, isValidHyperlinkUrl } from '@databases/utils/utils';
import React, { type FunctionComponent } from 'react';

import AbstractLink from './AbstractLink';

export interface HyperlinkLinkProps {
  hyperlink: Hyperlink;
  noFocus?: boolean;
  onClick?: (e: React.MouseEvent) => void;
  onFocus?: (e: React.FocusEvent) => void;
  noResolve?: boolean;
  useSmartLink?: boolean;
  showDisabledValue?: boolean;
}

/**
 * A component that renders a hyperlink as a link.
 */
const HyperlinkLink: FunctionComponent<HyperlinkLinkProps> = ({
  hyperlink,
  noFocus,
  onClick,
  onFocus,
  noResolve,
  useSmartLink,
  showDisabledValue,
}) => {
  let label;
  if (hyperlink.isLabelExplicit && hyperlink.label) {
    label = hyperlink.label;
  } else if (noResolve) {
    label = hyperlink.url;
  } else {
    label = hyperlink.label || getFallbackHyperlinkLabel(hyperlink.url);
  }

  return (
    <AbstractLink
      href={
        hyperlink.url && isValidHyperlinkUrl(hyperlink.url) ? hyperlink.url : undefined
      }
      onFocus={onFocus}
      onClick={onClick}
      noFocus={noFocus}
      iconBefore={hyperlink.url ? <LinkIcon LEGACY_size="small" label="" /> : undefined}
      noResolve={noResolve}
      useSmartLink={useSmartLink}
      showDisabledValue={showDisabledValue}
    >
      {label}
    </AbstractLink>
  );
};

export default HyperlinkLink;
